import React from 'react'
import PropTypes from 'prop-types'
import { Checkbox } from 'loyal-react'

const TermsOption = ({
  acceptTerms,
  acceptTermsEvent,
  showTermsEvent
}) => (
  <div className='row product-brand px-2'>
    <div className='col-12'>
      <div className='row mx-0 h-100 align-items-center'>
        <Checkbox
          style={{ position: 'relative', marginLeft: '20px' }}
          id='aceito_termos'
          checked={acceptTerms}
          className='col-auto'
          labelClass='l-0'
          outerLabel
          onChange={e => acceptTermsEvent(e.target.checked)}
        />
        <div className='col-auto'>
          <p className='txt-body-sm'>
            {' '}
                  Li e aceito os{' '}
            <a
              onClick={e => showTermsEvent()}
              className='txt-body-sm color-brand-2 txt-underline'
              role='button'
            >
                    termos do regulamento
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
)

TermsOption.propTypes = {
  acceptTerms: PropTypes.bool,
  showTermsEvent: PropTypes.func,
  acceptTermsEvent: PropTypes.func
}

export default TermsOption



// WEBPACK FOOTER //
// ./src/features/Donation/Sidebar/TermsOption.js